import { Reveal } from "@/components/common/Reveal";
import { useLead } from "@/components/common/LeadModal";

const IMG = "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/o0e8dp5n_pexels-yankrukov-8199174%20%281%29.webp";

export default function FinalCtaDual() {
  const { openLead } = useLead();
  return (
    <section className="relative overflow-hidden bg-white py-24 lg:py-32" data-testid="final-cta">
      <div className="relative mx-auto max-w-[1400px] px-5 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-2">
            <Reveal>
              <span className="mb-5 inline-block h-3 w-10 rounded-full bg-brand-red" />
              <h2 className="font-display text-3xl font-black leading-[0.98] tracking-tight text-brand-blue sm:text-4xl">
                Décidé à rejoindre Educaser Group ?
              </h2>
              <p className="mt-4 text-slate-500">
                Nous serons ravis de vous accompagner vers une qualification reconnue et un métier
                qui recrute. Nos conseillers vous guident à chaque étape.
              </p>
              <button onClick={() => openLead("inscription")} className="mt-6 rounded-full bg-brand-red px-7 py-3.5 font-bold text-white transition-colors hover:bg-brand-red-light" data-testid="final-cta-inscription">
                Je m'inscris
              </button>
            </Reveal>

            <Reveal delay={0.12}>
              <span className="mb-5 inline-block h-3 w-10 rounded-full bg-brand-blue" />
              <h2 className="font-display text-3xl font-black leading-[0.98] tracking-tight text-brand-blue sm:text-4xl">
                Besoin d'en savoir plus ?
              </h2>
              <p className="mt-4 text-slate-500">
                Formations, financements, centres, calendrier… N'hésitez pas à nous poser vos
                questions, nous sommes là pour vous accompagner.
              </p>
              <button onClick={() => openLead("rappel")} className="mt-6 rounded-full border-2 border-brand-blue px-7 py-3.5 font-bold text-brand-blue transition-colors hover:bg-brand-blue hover:text-white" data-testid="final-cta-rappel">
                Être rappelé
              </button>
            </Reveal>
          </div>

          <Reveal delay={0.2}>
            <div className="overflow-hidden rounded-3xl">
              <img src={IMG} alt="Stagiaires Educaser Group" className="h-[420px] w-full object-cover" loading="lazy" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
